import { render } from "./SurveySuccessView.vue?vue&type=template&id=a9c685d2"
import script from "./SurveySuccessView.vue?vue&type=script&lang=js"
export * from "./SurveySuccessView.vue?vue&type=script&lang=js"

import exportComponent from "/Users/appitry/Appitry/dscvry-browser/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__